import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import VN from "../components/VN";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { Row } from "react-bootstrap";
import {
  Select,
  TextField,
  Button,
  Container,
  Typography,
  Box,
  InputLabel,
  MenuItem,
  FormControl,
  Autocomplete,
  CircularProgress,
  FormHelperText,
  InputAdornment,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { apiRequest } from "../components/Config";
import ReCAPTCHA from "react-google-recaptcha";
import { UserDataContext } from "../components/UserDataContext";
import LocationSelect from "../components/LocationSelect";
import PasswordFields from "../components/PasswordFields";
import { API_URL } from "../App";
import Alerts from "../components/Alerts";
import { marginBottom } from "../App";

export default function RegisterNanny() {
  const { userData } = useContext(UserDataContext);
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [phone, setPhone] = useState("");
  const [voivodeshipList, setVoivodeshipList] = useState([]);
  const [citizenshipList, setCitizenshipList] = useState([]);
  const [cities, setCities] = useState([]);
  const [loadingCities, setLoadingCities] = useState(false);
  const [textLogin, setTextLogin] = useState("");
  const [showTextLogin, setShowTextLogin] = useState(false);
  const [textEmail, setTextEmail] = useState("");
  const [showTextEmail, setShowTextEmail] = useState(false);
  const [textPhone, setTextPhone] = useState("");
  const [showTextPhone, setShowTextPhone] = useState(false);
  const [captchaToken, setCaptchaToken] = useState(null);
  const [user, setUser] = useState();
  const [email, setEmail] = useState();
  const [apiResponse, setApiResponse] = useState({});
  const [showApiResponse, setShowApiResponse] = useState(false);
  const [countdown, setCountdown] = useState(5);
  const ClearApiResponse = () => {
    setShowApiResponse(false);
  };
  const validationSchema = Yup.object({
    user: Yup.string().required("Login jest wymagany"),
    email: Yup.string().email("Niepoprawny email"),
    phone: Yup.string()
      .required("Telefon jest wymagany")
      .length(9, "Telefon musi mieć 9 cyfr"),
    fullName: Yup.string().required("Nazwisko i imię wymagane"),
    birthyear: Yup.number()
      .typeError("Wybierz rok")
      .min(1960, "Niepoprawny rok")
      .max(new Date().getFullYear() - 28, "Minimum 28 lat")
      .required("Rok urodzenia wymagany"),
    password: Yup.string().min(6, "Min. 6 znaków").required("Hasło wymagane"),
    passwordrepeat: Yup.string()
      .oneOf([Yup.ref("password")], "Hasła muszą być identyczne")
      .required("Powtórz hasło"),
    voivodeship: Yup.string().required("Wybierz województwo"),
    city: Yup.object().nullable().required("Wybierz miasto"),
    rodo: Yup.boolean().oneOf([true], "Wymagana zgoda"),
    penality: Yup.boolean().oneOf([true], "Wymagana zgoda"),
    citizenship: Yup.string().required("Obywatelstwo jest wymagane"),
  });
  useEffect(() => {
    apiRequest("citizenships").then(setCitizenshipList);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const url = API_URL + `/verify-account-login`;
      try {
        const response = await axios.post(
          url,
          { login: user },
          {
            headers: {
              "Content-Type": "application/json",
            },
          },
        );
        if (parseInt(response.data.user) > 0) {
          setTextLogin("Takie konto już istnieje w systemie!");
          setShowTextLogin(true);
        } else {
          setShowTextLogin(false);
        }
      } catch (error) {
        console.log(error.message);
      }
    };
    fetchData();
  }, [user]);
  useEffect(() => {
    const fetchData = async () => {
      const url = API_URL + `/verify-account-email`;
      try {
        const response = await axios.post(
          url,
          { email: email },
          {
            headers: {
              "Content-Type": "application/json",
            },
          },
        );
        if (parseInt(response.data.email) > 0) {
          setTextEmail("Taki email już istnieje w systemie!");
          setShowTextEmail(true);
        } else {
          setShowTextEmail(false);
        }
      } catch (error) {
        console.log(error.message);
      }
    };
    fetchData();
  }, [email]);
  useEffect(() => {
    const fetchData = async () => {
      const url = API_URL + `/verify-account-phone`;
      try {
        const response = await axios.post(
          url,
          { phone: phone },
          {
            headers: {
              "Content-Type": "application/json",
            },
          },
        );
        if (parseInt(response.data.phone) > 0) {
          setTextPhone("Taki numer już istnieje w systemie!");
          setShowTextPhone(true);
        } else {
          setShowTextPhone(false);
        }
      } catch (error) {
        console.log(error.message);
      }
    };
    fetchData();
  }, [phone]);

  const fetchCities = async (id) => {
    setLoadingCities(true);
    const res = await apiRequest(`cities/${id}`);
    setCities(res || []);
    setLoadingCities(false);
  };

  const initialValues = {
    user: "",
    email: "",
    phone: "",
    fullName: "",
    birthyear: "",
    password: "",
    passwordrepeat: "",
    voivodeship: "",
    citizenship: "",
    city: null,
    rodo: false,
    penality: false,
  };

  return (
    <div>
      <VN userData={userData} />
      {showApiResponse && (
        <Row className="sticky-alerts-container">
          <Alerts data={apiResponse} />
        </Row>
      )}
      <Container maxWidth="sm">
        <Box mt={5}>
          <Typography variant="h5">Rejestracja opiekunki</Typography>

          {step === 1 && (
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={async (values) => {
                if (!captchaToken) {
                  setApiResponse({
                    title: "Potwierdź captcha",
                    severity: "warning",
                    info: "Potwierdzenie captcha wymagane",
                  });
                  setShowApiResponse(true);
                  return;
                }

                const payload = {
                  ...values,
                  city: values.city.id,
                  captcha: captchaToken,
                  accountType: 1,
                };
                const response = await apiRequest("register", "POST", payload);
                setPhone(values.phone);
                setStep(2);
              }}
            >
              {({
                values,
                handleChange,
                setFieldValue,
                errors,
                touched,
                isSubmitting,
              }) => {
                //console.log("ERRORS:", errors);
                return (
                  <Form>
                    <TextField
                      name="user"
                      label="Login"
                      fullWidth
                      value={values.user}
                      onChange={(e) => {
                        handleChange(e);
                        setUser(e.target.value);
                      }}
                      error={touched.user && Boolean(errors.user)}
                      helperText={touched.user && errors.user}
                    />
                    {showTextLogin && textLogin}
                    <TextField
                      name="email"
                      label="Email"
                      fullWidth
                      margin="normal"
                      value={values.email}
                      onChange={(e) => {
                        handleChange(e);
                        setEmail(e.target.value);
                      }}
                      error={touched.email && Boolean(errors.email)}
                      helperText={touched.email && errors.email}
                    />

                    {showTextEmail && textEmail}
                    <TextField
                      name="fullName"
                      label="Nazwisko i Imię"
                      fullWidth
                      margin="normal"
                      value={values.fullName}
                      onChange={handleChange}
                      error={touched.fullName && Boolean(errors.fullName)}
                      helperText={touched.fullName && errors.fullName}
                    />
                    <TextField
                      name="phone"
                      label="Telefon"
                      fullWidth
                      margin="normal"
                      value={values.phone}
                      onChange={(e) => {
                        handleChange(e);
                        setPhone(e.target.value.replace(/\D/g, "").slice(0, 9));
                        setFieldValue(
                          "phone",
                          e.target.value.replace(/\D/g, "").slice(0, 9),
                        );
                      }}
                      error={touched.phone && Boolean(errors.phone)}
                      helperText={touched.phone && errors.phone}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">+48</InputAdornment>
                        ),
                      }}
                    />
                    {showTextPhone && textPhone}
                    <FormControl
                      fullWidth
                      margin="normal"
                      error={touched.birthyear && Boolean(errors.birthyear)}
                    >
                      <InputLabel>Rok urodzenia</InputLabel>
                      <Select
                        name="birthyear"
                        value={values.birthyear}
                        onChange={handleChange}
                      >
                        {[...Array(60)].map((_, i) => {
                          const y = new Date().getFullYear() - 28 - i;
                          return (
                            <MenuItem key={y} value={y}>
                              {y}
                            </MenuItem>
                          );
                        })}
                      </Select>
                      {touched.birthyear && (
                        <FormHelperText>{errors.birthyear}</FormHelperText>
                      )}
                    </FormControl>
                    <PasswordFields
                      values={values}
                      handleChange={handleChange}
                      errors={errors}
                      touched={touched}
                    />
                    <FormControl
                      fullWidth
                      margin="normal"
                      error={touched.citizenship && Boolean(errors.citizenship)}
                    >
                      <InputLabel>Obywatelstwo</InputLabel>
                      <Select
                        value={values.citizenship}
                        onChange={(e) => {
                          const cId = e.target.value;
                          setFieldValue("citizenship", cId);
                        }}
                      >
                        {citizenshipList.map((v) => (
                          <MenuItem key={v.id} value={v.id}>
                            {v.name_pl}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <LocationSelect
                      values={values}
                      setFieldValue={setFieldValue}
                      errors={errors}
                      touched={touched}
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="penality"
                          checked={values.penality}
                          onChange={(e) =>
                            setFieldValue("penality", e.target.checked)
                          }
                          color="warning"
                        />
                      }
                      label={
                        <Typography variant="body2">
                          Oświadczam, że jestem osobą niekaraną w rozumieniu
                          przepisów prawa karnego, w szczególności za
                          przestępstwa przeciwko życiu i zdrowiu, wolności
                          seksualnej oraz obyczajności, oraz że nie toczy się
                          wobec mnie żadne postępowanie karne ani
                          karno-skarbowe.
                        </Typography>
                      }
                    />
                    {touched.penality && errors.penality && (
                      <FormHelperText error>{errors.penality}</FormHelperText>
                    )}
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="rodo"
                          onChange={handleChange}
                          color="primary"
                        />
                      }
                      label={
                        <Typography variant="body2">
                          Wyrażam zgodę na przetwarzanie danych zgodnie z{" "}
                          <a href="/polityka-prywatnosci" target="_blank">
                            Polityką prywatności.
                          </a>
                          .
                        </Typography>
                      }
                    />
                    {touched.rodo && errors.rodo && (
                      <FormHelperText error>{errors.rodo}</FormHelperText>
                    )}
                    <Box mt={2}>
                      <ReCAPTCHA
                        sitekey="6Ld8dZcsAAAAAI2kdXLZVwduM4ydXysrZRJju4qo"
                        onChange={setCaptchaToken}
                      />
                    </Box>
                    <Button
                      type="submit"
                      fullWidth
                      variant="contained"
                      sx={{ mt: 2 }}
                      disabled={isSubmitting}
                    >
                      Zarejestruj i wyślij SMS
                    </Button>
                  </Form>
                );
              }}
            </Formik>
          )}
          {step === 2 && (
            <Formik
              initialValues={{ code: "" }}
              onSubmit={async (values) => {
                const response = await apiRequest("verify-sms", "POST", {
                  phone,
                  code: values.code,
                });
                if (response.success === true) {
                  setApiResponse({
                    title: "Sukces",
                    severity: "success",
                    info: "Konto aktywowane pomyślnie. Możesz się zalogować i uzupełnić dane swojego profilu.",
                  });
                  setShowApiResponse(true);
                  setCountdown(5);
                  const timer = setInterval(() => {
                    setCountdown((prev) => prev - 1);
                  }, 1000);
                  setTimeout(() => {
                    clearInterval(timer);
                    navigate("/login");
                  }, 5000);
                }
                if (response.success === false) {
                  setApiResponse({
                    title: "Nieprawidłowy kod SMS!",
                    severity: "warning",
                    info: "Nie udało się aktywować konta",
                  });
                  setShowApiResponse(true);
                }
              }}
            >
              {({ handleChange }) => (
                <Form>
                  <TextField
                    name="code"
                    label="Kod SMS"
                    fullWidth
                    onChange={handleChange}
                  />
                  <Button type="submit" fullWidth sx={{ mt: 2 }}>
                    Potwierdź
                  </Button>
                </Form>
              )}
            </Formik>
          )}
        </Box>
      </Container>
    </div>
  );
}
